module.exports = require("os");


/*****************
 ** WEBPACK FOOTER
 ** external "os"
 ** module id = 11
 ** module chunks = 0
 **/